import React, { FC } from 'react';
import IIconBullet from '../../../interfaces/elements/iconBullet';
import * as StyledIconBulletList from './iconBulletList.styles';

interface Props {
	bulletList: IIconBullet[];
}

const IconBulletList: FC<Props> = ({ bulletList }) => {
	return (
		<StyledIconBulletList.Wrapper>
			{bulletList.map(bullet => (
				<StyledIconBulletList.IconBullet key={bullet.Values.BulletText}>
					{bullet.Values.Icon.Src !== '' && bullet.Values.Icon.Src !== 'No Icon' ? (
						<StyledIconBulletList.IconImage src={`${bullet.Values.Icon.Src}`} />
					) : (
						<StyledIconBulletList.ImagePlaceholder />
					)}
					<StyledIconBulletList.BulletTextWrapper>
						<StyledIconBulletList.BulletText>{bullet.Values.BulletText}</StyledIconBulletList.BulletText>
						<StyledIconBulletList.BulletSubtext>
							{bullet.Values.BulletSubtext}
						</StyledIconBulletList.BulletSubtext>
					</StyledIconBulletList.BulletTextWrapper>
				</StyledIconBulletList.IconBullet>
			))}
		</StyledIconBulletList.Wrapper>
	);
};

export default IconBulletList;
